import { Button, Table } from 'antd';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router';
import { TableSkeleton } from '../../../../../shared/components/TableSkeleton';
import { newVehicleClassPath, vehicleClassPath } from '../../tyre-layouts/tyre-layouts.paths';
import type { TruckClass } from '../../../reference-data.api';
import { buildTruckClassColumns } from './build-truck-class-columns';

interface TruckClassesPanelProps {
  classes: TruckClass[];
  loading: boolean;
  onDeactivate: (row: TruckClass) => Promise<void>;
  onReactivate: (row: TruckClass) => Promise<void>;
}

/**
 * Client-side paging (Ant's default) — the small-fixed-catalogue exception to server-side lists (CLAUDE.md → Lists and tables).
 * A class is created and edited on its own page, with its vehicle beside the form.
 */
export function TruckClassesPanel({ classes, loading, onDeactivate, onReactivate }: TruckClassesPanelProps) {
  const navigate = useNavigate();
  const columns = buildTruckClassColumns({ onEdit: (row) => navigate(vehicleClassPath('truck_class', row.code)), onDeactivate, onReactivate });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button type="primary" icon={<Plus className="size-4" />} onClick={() => navigate(newVehicleClassPath('truck_class'))}>
          New truck class
        </Button>
      </div>
      {loading ? (
        <TableSkeleton label="Loading truck classes" />
      ) : (
        <Table rowKey="id" dataSource={classes} columns={columns} pagination={{ pageSize: 25 }} scroll={{ x: 'max-content' }} />
      )}
    </div>
  );
}
